module.exports = __webpack_public_path__ + "img/8-s.90d416bb.png";